import script from "./step5AdvertRaised.vue?vue&type=script&setup=true&lang=ts"
export * from "./step5AdvertRaised.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__